export default __webpack_public_path__ + "static/media/Bordero.253d05ab.svg";